(() => {
  if (window.__bcuSubscriptionBuilderUiLoaded) return;
  window.__bcuSubscriptionBuilderUiLoaded = true;

  const controlSelector = '[data-bcu-subscription-date-control]';

  const initializeControl = (control) => {
    if (!control || control.dataset.bcuDateControlReady === 'true') return;
    const input = control.querySelector('[data-bcu-subscription-start-date]');
    const display = control.querySelector('[data-bcu-subscription-date-display]');
    if (!input) return;

    control.dataset.bcuDateControlReady = 'true';
    const formatDisplayDate = (value) => {
      const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      return match ? `${match[3]}.${match[2]}.${match[1]}` : 'dd.mm.yyyy';
    };
    const syncValueState = () => {
      control.classList.toggle('has-value', Boolean(input.value));
      if (display) display.textContent = formatDisplayDate(input.value);
    };
    const openNativePicker = () => {
      if (input.disabled || input.readOnly) return;
      input.focus({ preventScroll: true });
      if (typeof input.showPicker !== 'function') return;
      try {
        input.showPicker();
      } catch (error) {
        // The normal input click remains the fallback when a browser rejects showPicker().
      }
    };
    control.addEventListener('click', openNativePicker);
    input.addEventListener('input', syncValueState);
    input.addEventListener('change', syncValueState);
    syncValueState();
  };

  const initializeControls = (root = document) => {
    if (root.matches?.(controlSelector)) initializeControl(root);
    root.querySelectorAll?.(controlSelector).forEach(initializeControl);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeControls(), { once: true });
  } else {
    initializeControls();
  }

  document.addEventListener('shopify:section:load', (event) => initializeControls(event.target));
})();
